/**
 * @generated SignedSource<<04972a90dc6e581a011b2be78ab31703>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditTransport_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlights_data" | "PackageEditTransportServices_data">;
  readonly " $fragmentType": "PackageEditTransport_data";
};
export type PackageEditTransport_data$key = {
  readonly " $data"?: PackageEditTransport_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransport_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditTransport_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditTransportServices_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditTransportFlights_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "87a23b4bc8ddbc964d74945ebc15b1ff";

export default node;
